import { Injectable, signal } from '@angular/core';
import { IUser } from '../../interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})
export class ManageUserSignalService {
  user = signal<IUser | undefined>(undefined);

  setLoggedInUser(user: IUser) {
    this.user.set(user);
  }

  getLoggedInUser(): IUser | undefined {
    return this.user();
  }
}
